var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ion-app',{staticClass:"ion-page"},[(_vm.busy)?_c('full-width-spinner'):_c('v-app',[_c('app-header'),_c('div',{staticClass:"content"},[_c('ion-vue-router',{staticClass:"router"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }